import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    updateTypes: -1,
    loadTypes: -1,
    sendMessage: -1,
    loadList: -1,
    details: -1,
    createSummary: -1,
    add: -1,
  },
  types: [],
  list: [],
  details: 0,
  add: null,
  meta: {
    pagination: {
      total: 0,
      pages: 0,
    },
  },
  error: null,
};


export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.APPOINTMENT_TYPE_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTypes: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_TYPE_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTypes: 1,
        },
        types: payload.data,
      };
    case ACTION_TYPES.APPOINTMENT_TYPE_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTypes: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_TYPE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateTypes: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_TYPE_UPDATE_SUCCEED: {
      // const newList = payload.data.map(({ appointmentType, duration }) => ({ ...appointmentType, duration }));
      return {
        ...state,
        status: {
          ...state.status,
          updateTypes: 1,
        },
        // types: mergeLists(state.types, newList),
      };
    }
    case ACTION_TYPES.APPOINTMENT_TYPE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateTypes: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_SEND_MESSAGE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          sendMessage: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_SEND_MESSAGE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          sendMessage: 1,
        },
      };
    case ACTION_TYPES.APPOINTMENT_SEND_MESSAGE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          sendMessage: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_MARK_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          marking: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_MARK_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          marking: 1,
        },
      };
    case ACTION_TYPES.APPOINTMENT_MARK_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          marking: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENTS_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENTS_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        list: payload.result.data,
        meta: payload.result.meta,
      };
    case ACTION_TYPES.APPOINTMENTS_GET_FAILED:
      return {
        ...state,
        status: {
          loadList: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          details: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          details: 1,
        },
        details: payload.result.data,
      };
    case ACTION_TYPES.APPOINTMENT_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          details: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_SUMMARY_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          createSummary: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_SUMMARY_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          createSummary: 1,
        },
      };
    case ACTION_TYPES.APPOINTMENT_SUMMARY_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          createSummary: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_ADD_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          add: 0,
        },
      };
    case ACTION_TYPES.APPOINTMENT_ADD_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          add: 1,
        },
        add: payload.result.data,
      };
    case ACTION_TYPES.APPOINTMENT_ADD_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          add: 2,
        },
        error,
      };
    case ACTION_TYPES.APPOINTMENT_RESET_STATE:
      return {
        ...state,
        status: initialState.status,
      };

    default:
      return state;
  }
}
